module.exports = __webpack_public_path__ + "img/monastery.044b3dab.jpeg";